import $ from 'jquery';
import 'block-ui';
import 'jgrowl';
import 'bootstrap';
import Translator from './stdjs/translate-service';

// polyfill for ie11
import matchAll from 'string.prototype.matchall';
var from = require('array.from');
matchAll.shim();
from.shim();

import { destroyMessages, initialiseMessaging } from 'stdjs/validation';

$(document).ready(function() {
    
    initialiseMessaging();

    $(document).ajaxStart(function() {
        $.blockUI({
          message: "<img src=\"/images/ajax-loader.gif\" />",
          css: {
            padding:        0,
            margin:         0,
            textAlign:      "center",
            color:          "#000",
            border:         "0",
            backgroundColor:"transparent",
            cursor:         "wait",
            width:          "auto",
            height:         "auto",
            transform:      "translateX(-50%) translateY(-50%)",
            top:            "50%",
            left:           "50%",
            zIndex:         "9999",
          },
          overlayCSS:  {
            backgroundColor: "#ffffff",
            opacity:         0.75,
            cursor:          "wait",
            zIndex:         "9999",
          }
        });
    }).ajaxStop($.unblockUI);
    
    destroyMessages();
    
    if (typeof infoMessages !== "undefined"){
        $.jGrowl(infoMessages, {header: Translator.tr("Information"), theme: "jInfo"});
    }
    
    if (typeof errorMessages !== "undefined"){
        $.jGrowl(errorMessages, {header: Translator.tr("Error"), theme: "jError", sticky: true});
    }
    
    if (typeof warningMessages !== "undefined"){
        $.jGrowl(warningMessages, {header: Translator.tr("Warning"), theme: "jWarn", sticky: true});
    }
    
    if ($(".helpIcon").length){
      $('.helpIcon').tooltip();
    }
    
    $(".form__field").focusin(function(e){
        $(this).closest(".iconInput").addClass("selected");
    });

    $(".form__field").on("focusout change", function(e){
      $(this).closest(".iconInput").removeClass("selected");

      if ($(this).val() === "" || (Array.isArray($(this).val()) && $(this).val().length === 0)){
        $(this).closest(".iconInput").find(".form__label").removeClass("populated");
      } else {
        $(this).closest(".iconInput").find(".form__label").addClass("populated");        
      }
    });
    
    $(".checkbox__form__label").click(function(e){
      e.stopPropagation();
    });

    $(".checkbox-container input[type=checkbox]").change(function(e){
      var container = $($(this).closest(".checkbox-container"));
      var label = $(container.find(".checkbox__form__label"));
      if ($(this).prop("checked")){
        label.addClass("populated");
      } else {
        label.removeClass("populated");

      }
    });

    $(".checkbox-container").click(function(e){
      if ($(this).parent().hasClass("switchContainer")){
        return;
      }
      e.stopPropagation();
      var label = $($(this).find(".checkbox__form__label"));
      if (label.length > 0){
        label.trigger("click");
      }
    });

    $(".form__field").each(function(i){
      if ($(this).val() !== "" && ! $.isEmptyObject($(this).val())){
          $(this).closest(".iconInput").find(".form__label").addClass("populated");        
      } else {
          $(this).closest(".iconInput").find(".form__label").removeClass("populated");
      }
    });

    $(".iconInput .clear-input-btn").click(function(e){
      e.preventDefault();
    })

    $(".select2").on("focusin", ".select2-search__field", (function(e){
        $(this).closest(".form__group").find(".form__label").addClass("populated");
    }));

    /*$(".select2").on("select2:close", function(e){
        if($(this).parent().find(".select2-selection__rendered").children().length <= 1){
            //$(this).parent().find(".form__label").removeClass("populated");
        }
    });*/

    $(".select2").on("focusin", ".select2-search__field", (function(e){
      $(this).closest(".form__group").find(".form__label").addClass("populated");
    }));

    $(".select2").on("change.select2", function(e){
      if ($(this).hasClass( "select2-hidden-accessible" )  &&  $(this).select2('data').length > 0){
        $(this).closest(".form__group").find(".form__label").addClass("populated");
      } else {
        $(this).closest(".form__group").find(".form__label").removeClass("populated");
      }
    });

    $(".bannerTitle").click(function(e){
      location.href = welcomeUrl;
    });

});